<template>
  <no-ssr>
  <section class="contacts-section" v-if="load">
    <header-inner/>
    <wrapper :line-borders="false" :line-center="true" class=" page--bottom">
      <div class="main-title"><h1 class="text-center">{{privacy.headline}}</h1></div>
      <div class="text" v-html="privacy.htmltext"></div>
    </wrapper>
  </section>
  </no-ssr>
</template>

<style lang="scss" scoped>

</style>

<script>
  import HeaderInner from '~/components/header/HeaderInner'
    export default {
      name: "oferta",
      head () {
        return {
          title: 'Политика конфиденциальности',
          link: [{ rel: 'canonical', href: process.env.base + this.$route.path }],
          meta: [

          ]
        }
      },
      components: {
        HeaderInner,
      },
      computed: {
        load() {
          return this.$store.getters['main/privacy']['loaded']
        },
        privacy() {
          return this.load ? this.$store.getters['main/privacy']['item'][0] : []
        },
      },
      mounted() {
        if (!this.load) this.$store.dispatch('main/fetchPrivacy');
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// pages/oferta.vue